import { StaticImport } from "next/dist/shared/lib/get-img-props";
import { ImageProps, VideoProps } from "../types";

export const getImage = (
  img: string | StaticImport | ImageProps,
): string | StaticImport => {
  if (
    typeof img === "object" &&
    !("width" in img && "height" in img) &&
    "src" in img
  ) {
    return img.src;
  }
  return img as StaticImport | string;
};

export const getImageSrc = (
  img: string | StaticImport | ImageProps,
): string => {
  if (typeof img === "string") return img;
  if (typeof img === "object" && "src" in img) {
    if (typeof img.src === "object" && "default" in img.src)
      return img.src.default.src;
    else return img.src as string;
  }
  throw Error("Unknown image type");
};

export const getImageProp = (
  prop: string,
  img: string | StaticImport | ImageProps,
): any => {
  if (typeof img === "object" && img.hasOwnProperty(prop))
    return (img as any)[prop];
  return undefined;
};

export const getVideoProp = (prop: string, video: string | VideoProps): any =>
  getImageProp(prop, video);

export {
  CARD_GRID_2,
  CARD_GRID_3,
  CARD_GRID_4,
  TWO_COLS_CARD,
  FULL_WIDTH,
  HORIZONTAL_SLIDE,
} from "./sizes";
